import {Link} from "react-router-dom";
import "./styles/cpa.scss";
import { motion } from "framer-motion"
import ServiceNavbar from "./components/ServiceNavbar";

function Cpa() {
    return (
        <>
            {/* <!-- banner --> */}
            <div className="banner">
                <motion.div
                        initial={{ opacity: 0, x:-100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                        }}>
                    <img src="./cpaImg/CPA.jpg" alt=""/>
                </motion.div>
                <div className="cpabannertext dis">
                    Becker<br/>
                    CPA<br/>
                    <div className="fs-1 dis">
                        Exam Review
                    </div>
                    <div className="fx dis">
                        <button type="button" className="btn btn-outline-secondary dis"><a href="#why" className="text-secondary">詳情介紹</a></button>
                        <button type="button" className="btn btn-secondary dis me-3"><Link className="text-light" to={`/registration?parent_id=1`}>申請報名</Link></button>
                    </div>
                </div>
            </div>
            {/* <!-- Service Nav--> */}
            <ServiceNavbar/>
            {/* <!-- CPAsubNav --> */}
            <div className="container-fluid bgb">
                <div className="container">
                    <div className="cpasubnav">
                        <a href="#why"><div>Why USCPA</div></a>
                        <a href="#examsubjects"><div>考試科目與<br/>題型配比</div></a>
                        <a href="#examtimeline"><div>考試時間與<br/>成績保留原則</div></a>
                        <a href="#eligibility"><div>應考步驟與<br/>報考資格</div></a>
                        <a href="#protocol"><div>雙照計劃</div></a>
                        <a href="#protocol2"><div>證照互認協議</div></a>
                    </div>
                </div>
            </div>
            {/* <!-- CPA --> */}
            <div className="beckertitlename mb100 mt100" id="why">Why USCPA</div>
            <div className="container whycpa mb100">
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_01.svg" alt=""/>
                            <div className="fs-5">美國法律保障</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-5">美國註冊會計師 (Certified Public Accountant，簡稱 CPA) 執照具美國法律約束力與保障，由美國會計師協會 (AICPA) 舉辦統一會計師考試、由各州依法核發執照。</div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_02.svg" alt=""/>
                            <div className="fs-5">全球會計師始祖</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">美國會計師是全球第一個需通過會計專業考試取得的執業證照，也是全球會計師(CPA) 的始祖，推行至今已逾百年，在全球各國皆享有高認可度，是世界上規模最大、最為國際化的法定會計師專業資格。</div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_03.svg"alt=""/>
                            <div className="fs-5">國際職場競爭力</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">全球化影響下，跨國企業對「具有國際證照的財會人才」需求大增，會計專業更因可與不同產業結合，發展性隨之加大；美國 CPA 可結合並抵換多國財會專業證照，對需要取得 CPA 執業頭銜、瞭解美國會計制度的管理者而言，除了增加在跨國職場上的競爭力外，更可提升個人專業信用度與權威。</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container whycpa mb100">
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_04.svg"alt=""/>
                            <div className="fs-5">國際高度專業能力</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">美國 CPA 是國際性會計師事務所、政府單位招募指標，更是跨國企業、外商公司炙手可熱的高薪人才。通過美國會計師考試，代表分析判斷、思考視野以及語文能力皆符合國際水準，並擁有跨國商業溝通的高度專業能力。</div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_05.svg"alt=""/>
                            <div className="fs-5">留學、移民絕對優勢</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">通過 CPA 考試者，在赴美留學、申請名校時佔加分優勢，畢業後取得當地實習機會較同期畢業生更大，獲得正式工作機會也較不具 CPA 資格之留學生多，是移民美國、技術移民澳洲及加拿大並立即進入當地職場的快捷方式。</div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-3 sixsq">
                <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_06.svg"alt=""/>
                            <div className="fs-5">全球趨勢、國際認可</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">通過美國會計師考試代表熟悉 IFRS 與 U.S. GAAP 會計雙準則，更強調對美國法規和商業環境的瞭解；持有美國會計師，在國際會計師事務所或跨國企業中，和跨國同事協力工作、或和國際客戶商談生意時，將賦予有力話語權與說服力。</div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- USCPA 有助生涯&職涯規劃 --> */}
            <div className="container mb100 mt100">
                <div className="br mt100 mb100"></div>
                <div className="beckertitlename mb100 mt100">USCPA 有助生涯&職涯規劃</div>
                <motion.div
                            initial={{ opacity: 0, x:-100 }}
                            whileInView={{ opacity: 1, x:0 }}
                            transition={{
                            delay: 0.4,
                            default: { ease: "linear" },
                        }}>
                <div className="d-flex justify-content-around cpaappliancearea">
                    <div className="cpaappliance">
                        <div className="sqcontent">
                            <div className="sqtitle">在職人士</div>
                            <div className="sqdes">專業強化/交換工作/職務晉升/職涯轉換/自行開業/國際移動</div>
                        </div>
                    </div>
                    <div className="cpaappliance">
                        <div className="sqcontent">
                            <div className="sqtitle">留學生</div>
                            <div className="sqdes">申請名校/Pre-MBA專業訓練/申請工作實習/爭取實習後留任</div>
                        </div>
                    </div>
                    <div className="cpaappliance">
                        <div className="sqcontent">
                            <div className="sqtitle">大學生</div>
                            <div className="sqdes">就業前的專業預備/抵免台會雙照計畫</div>
                        </div>
                    </div>
                    <div className="cpaappliance">
                        <div className="sqcontent">
                            <div className="sqtitle">移民需求</div>
                            <div className="sqdes">申請美國移民加分/技術移民澳洲、加拿大、新加坡的快捷方式</div>
                        </div>
                    </div>
                </div>
                </motion.div>
                <div className="br mt100 mb100"></div>
                {/* <!-- 考試科目與題型配比 --> */}
                <div className="beckertitlename mb100 mt100" id="examsubjects">考試科目與題型配比</div>
                <div className="examtable">
                    <div className="examsubjects fr  ">
                        <img className="" src="./cpaImg/far.svg"alt=""/>
                        <div className="subjectname ">FAR</div>
                        <div className="fullname ">Financial Accounting & Reporting</div>
                        <div className="chmean ">財務會計與報告</div>
                        <div className="des">一般公認會計準則(GAAP)，包含企業、非營利事業和政府會計</div>
                        <div className="examtime tfr">考試時間：4小時</div>
                        <div className="qutype mfr">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題 (MCQ) 50題</span>
                                    <span className="mmt">50%</span>
                                </li>
                                <li>
                                    <span className="mma">情境模擬題 (Task-based Simulation)7大題</span>
                                    <span className="mmt">50%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="examsubjects au ">
                        <img className="" src="./cpaImg/aud.svg"alt=""/>
                        <div className="subjectname">AUD</div>
                        <div className="fullname">Auditing & Attestation</div>
                        <div className="chmean">審計與鑑證</div>
                        <div className="des">審計服務、簽證服務、<br/>會計及核閱服務</div>
                        <div className="examtime tau">考試時間：4小時</div>
                        <div className="qutype mau">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題 (MCQ) 78題</span>
                                    <span className="mmt">50%</span>
                                </li>
                                <li>
                                    <span className="mma">Task-Based Simulation 7大題</span>
                                    <span className="mmt">50%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="examsubjects rg  ">
                        <img className="" src="./cpaImg/reg.svg"alt=""/>
                        <div className="subjectname">REG</div>
                        <div className="fullname">Taxation and Regulation</div>
                        <div className="chmean">稅務與法規</div>
                        <div className="des">美國聯邦稅法、定期性或一次性個人與企業稅務處理、商事法</div>
                        <div className="examtime trg">考試時間：4小時</div>
                        <div className="qutype mrg">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題72題</span>
                                    <span className="mmt">50%</span>
                                </li>
                                <li>
                                    <span className="mma">Task-Based Simulation 8大題</span>
                                    <span className="mmt">50%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
                <div className="beckertitlename mb100 mt100" id="examsubjects">專科 (discipline) 考試</div>
                <div className="examtable">
                    <div className="examsubjects br  ">
                        <img className="" src="./cpaImg/far.svg"alt=""/>
                        <div className="subjectname ">BAR</div>
                        <div className="fullname ">Business Analysis and Reporting</div>
                        <div className="chmean ">商業分析與報告</div>
                        <div className="des">成本會計、財報分析、政府會計、財務管理、風險管理</div>
                        <div className="examtime tbr">考試時間：4小時</div>
                        <div className="qutype mbr">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題 (MCQ) 50題</span>
                                    <span className="mmt">50%</span>
                                </li>
                                <li>
                                    <span className="mma">情境模擬題 (Task-based Simulation)7大題</span>
                                    <span className="mmt">50%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="examsubjects ic  ">
                        <img className="" src="./cpaImg/aud.svg"alt=""/>
                        <div className="subjectname">ISC</div>
                        <div className="fullname">Information Systems and Controls</div>
                        <div className="chmean">資訊系統與控制</div>
                        <div className="des">資訊系統、資料管理、資安機密、服務組織控制報告 (SOC)</div>
                        <div className="examtime tic">考試時間：4小時</div>
                        <div className="qutype mic">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題 (MCQ) 82題</span>
                                    <span className="mmt">60%</span>
                                </li>
                                <li>
                                    <span className="mma">情境模擬題 (Task-based Simulation) 6大題</span>
                                    <span className="mmt">40%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="examsubjects tp  ">
                        <img className="" src="./cpaImg/reg.svg"alt=""/>
                        <div className="subjectname">TCP</div>
                        <div className="fullname">Tax Compliance and Planning</div>
                        <div className="chmean">稅務遵循與規劃</div>
                        <div className="des">美國聯邦稅法、個人與企業之非固定稅務處理、稅務規劃、個人財務規劃</div>
                        <div className="examtime ttp">考試時間：4小時</div>
                        <div className="qutype mtp">
                            <ul>
                                <li>
                                    <span className="mma">題型</span>
                                    <span className="mmt">配比</span>
                                </li>
                                <li>
                                    <span className="mma">單選題68題</span>
                                    <span className="mmt">50%</span>
                                </li>
                                <li>
                                    <span className="mma">情境模擬題 (Task-based Simulation) 7大題</span>
                                    <span className="mmt">50%</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
                <div className="br mn100 mt100"></div>
                {/* <!-- 四科考試架構及考試注意事項 --> */}
                <div className="beckertitlename mb-5 mt100">各科考試架構、範圍簡介</div>
                <div className="text-center w-75 m-auto">
                美國註冊會計師考試為觀念導向的考試，考生應全面了解考試概念及內容重點，正確判斷題意之外，
                也要有靈活思考以增快答題速度。另外可從題目練習之中學習答題技巧及方向，而非死背答案。
                </div>
                <div className="d-flex subjecttable mb100 mt100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4 dis">
                            <img className="subpic" src="./cpaImg/far_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">Financial Accounting & Reporting</div>
                        <div className="mb100">「FAR 財務會計」是新制考試的學科 (core exams) 之一，每個考生都必須通過 FAR；這也是台灣人相對最熟悉、學習底子最好的一科，往年通過率皆比其他學科 (審計與法規) 更高。

                        此科範圍包含一般公認會計準則 (U.S. GAAP)，以及企業、非營利事業、政府會計，選擇 FAR 作為第一科準備的考試，是個好的起點，為後續準備其他科目預先建立基礎概念。

                        備考過程中，應注意國內 IFRS 及美國 U.S. GAAP 會計準則之差異，同時對美國的財會公報體系應有一定程度的瞭解。相信只要充份使用 Becker 教材刷題練習，考生應可順利通過此科。
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area I</span>
                                <span className="tml">Financial Reporting</span>
                                <span className="tmm">財務報告</span>
                                <span className="tmm">30-40%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area II</span>
                                <span className="tml">Select Balance Sheet Accounts</span>
                                <span className="tmm">特定資產負債表科目</span>
                                <span className="tmm">30-40%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area III</span>
                                <span className="tml">Select Transactions</span>
                                <span className="tmm">特定交易</span>
                                <span className="tmm">25-35%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                
                <div className="d-flex subjecttable mb100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4">
                            <img className="subpic dis" src="./cpaImg/reg_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">Auditing and Attestation 審計與鑑證 (簡稱 AUD)</div>
                        <div className="mb100">在審計基本觀念及方法上，台灣與美國大致相同， 惟在相關法令規定上差異較大。尤其在2001 年安隆（Enron）案發生後，相關審計規定不斷更新，沙賓法案（Sarbanes-Oxley Act）通過及 PCAOB 設立，對於審計專業人員之影響甚大。

                        本科目為必考學科 (core exam)，學習範圍主要包含審計服務、簽證服務、會計及核閱服務等，其中包含應用資訊科技概念、數據分析技術進行風險評估與完成規劃程序，並以專業判斷審慎評估查核證據，採用抽樣方式覆核原始憑證，用以辨認問題、分析事實及規劃適當查核程序。

                        針對此學科，Becker 以完整的內容美國審計應用與規定，對於考生未來在大型會計師事務所或在跨國集團擔任財會主管時，將有極大之助益。
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area I</span>
                                <span className="tml">Ethics, Professional Responsibilities and General Principles</span>
                                <span className="tmm">職業道德、會計師專業責任與一般原則</span>
                                <span className="tmm">15-25%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area II</span>
                                <span className="tml">Assessing Risk and Developing a Planned Response</span>
                                <span className="tmm">評估風險與制訂應對計畫</span>
                                <span className="tmm">25-35%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area III</span>
                                <span className="tml">Performing Further Procedures and Obtaining Evidence</span>
                                <span className="tmm">執行查核程序與取得查核證據</span>
                                <span className="tmm">30-40%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area IV</span>
                                <span className="tml">Forming Conclusions and Reporting</span>
                                <span className="tmm">完成結論與查核報告</span>
                                <span className="tmm">10-20%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area V</span>
                                <span className="tml">Federal Taxation of Entities</span>
                                <span className="tmm">公司稅</span>
                                <span className="tmm">28-38%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="d-flex subjecttable mb100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4">
                            <img className="subpic dis" src="./cpaImg/aud_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">Taxation and Regulation 稅務與法規 (簡稱 REG)</div>
                        <div className="mb100">對非美籍的華人考生而言，求學過程中甚少涉獵英美法，因此 REG 向來是相對陌生的科目；但毋須擔憂：根據歷年 NASBA Candidate Performance Book（付費數據報告書）台灣考生平均通過分數為亞洲第二、僅比中國大陸低 0.1 分，絕大多數皆在沒有修過美國商法稅法學分的情況之下，順利通過 REG 考試。
                        本科目學習範圍包含 ── 美國聯邦稅法、定期性或一次性個人與企業稅務處理、商事法等；美國商事法及稅法體系複雜且龐大，著重對美國文化思考脈絡的理解推導、和對法規架構的熟悉。Becker 教材美師影片、與中文課程講師皆持美國律師資格專業背景、法律事務所實務經驗，深入淺出解說全新的 REG 考科，幫助非美籍的華人考生快速理解、適應新制考試。
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area I</span>
                                <span className="tml">Ethics, Professional Responsibilities and Federal Tax Procedures</span>
                                <span className="tmm">聯邦稅法、道德專業與法律責任</span>
                                <span className="tmm">10–20%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area II</span>
                                <span className="tml">Business Law</span>
                                <span className="tmm">商事法</span>
                                <span className="tmm">15–25%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area III</span>
                                <span className="tml">Federal Taxation of Property Transactions</span>
                                <span className="tmm">聯邦稅 - 產權交易</span>
                                <span className="tmm">5–15%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area IV</span>
                                <span className="tml">Federal Taxation of Individuals</span>
                                <span className="tmm">聯邦稅 - 個人稅</span>
                                <span className="tmm">22–32%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area V</span>
                                <span className="tml">Federal Taxation of Entities (including tax preparation)</span>
                                <span className="tmm">聯邦稅 - 公司稅 (含稅務申報)</span>
                                <span className="tmm">23–33%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="detexct">
                        以下三科是專科考試 (discipline exams)，每個考生需選擇其中一科通過考試（也僅能通過其中一科）。
                        Becker Taiwan 學員可透過閱讀教材軟體、或預約諮詢，依照個人學習背景、讀書狀況等，決定選擇哪一門專科考試、如何安排科目順序。
                    </div>
                <div className="d-flex subjecttable mb100 mt100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4 dis">
                            <img className="subpic" src="./cpaImg/far_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">
                            Business Analysis and Reporting 商業分析與報告 (簡稱 BAR)
                        </div>
                        <div className="mb100">
                            BAR (商業分析) 可說是進階版本的 FAR (財務會計)，兩者關聯性最高；BAR 中的高級會計學、成本與管理會計學、財務分析等考試內容，皆建立在 FAR 中學習過的概念上。
                            對於會計本科系考生而言， BAR 是三門專科 (discipline exam) 中能較快適應的一科，因此多數選擇此專科應考；在準備 FAR 科目後面銜接繼續準備 BAR，將有內容連貫、學習效率加乘的效果。

                            準備 BAR 考試，將幫助您習得以下技能和專長：
                            <div className="barli">
                                <ul>
                                    <li>資料分析</li>
                                    <li>財務風險管理、規劃</li>
                                    <li>複雜的會計處理</li>
                                    <li>州政府、地方政府會計</li>
                                </ul>
                            </div>
                            準備 BAR 過程中學習到的技能，適合以下職涯發展：
                            <div className="barli">
                                <ul>
                                    <li>審計員</li>
                                    <li>在企業的會計部門工作</li>
                                    <li>財務總監 (controller)</li>
                                    <li>主辦會計</li>
                                    <li>CFO 或 CEO</li>
                                </ul>
                            </div>
                            Becker 的 BAR 課程由業界經歷豐富的講師教授，有效幫助考生理解複雜度與實用性兼具的專業科目，學習精準解題和得分、同時累積相同重要的實務應用技巧，幫助未來在工作上能快速理解問題與勝任。
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area I</span>
                                <span className="tml">Business Analysis</span>
                                <span className="tmm">商業分析</span>
                                <span className="tmm">40-50%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area II</span>
                                <span className="tml">Technical Accounting and Reporting</span>
                                <span className="tmm">較複雜的會計與報告</span>
                                <span className="tmm">35-45%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area III</span>
                                <span className="tml">State and Local Governments</span>
                                <span className="tmm">州政府與當地政府會計</span>
                                <span className="tmm">10-20%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="d-flex subjecttable mb100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4">
                            <img className="subpic dis" src="./cpaImg/reg_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">Information Systems and Controls 資訊系統與控制 (簡稱 ISC)</div>
                        <div className="mb100">
                            <div className="tmbk">
                            ISC 是三選一專科 (discipline exams) 之中最資訊科技份量最多的，適合修過基礎資訊系統學分、或擁有相關工作經驗的考生選擇；根據 AICPA 發布的2024新制考試藍圖報告顯示，相較於會計系背景者選考 BAR 時需應付的出題範圍難度，ISC 對於「有資訊背景者」會是絕對容易上手、應考的一科。

                            若您具有以下幾項知識能力，ISC 極可能是最適合您的一科：
                            <div className="barli">
                                <ul>
                                    <li>資料管理</li>
                                    <li>資訊系統</li>
                                    <li>資訊安全</li>
                                    <li>商業流程模型</li>
                                    <li>系統與組織控制</li>
                                </ul>
                            </div>
                            準備 ISC 這一科時獲取的知識技能，能裝備自己、往以下職涯發展：
                            <div className="barli">
                                <ul>
                                    <li>資料管理 (數據經理)</li>
                                    <li>數據工程師/資料科學家</li>
                                    <li>CIO 或 CTO</li>
                                    <li>電腦審計員</li>
                                </ul>
                            </div>
                            現今的會計與審計是離不開資訊科技的。Becker 的 ISC 課程由持資訊與會計雙重專業背景、實務經歷豐富的講師授課，幫助各位考生、無論原本是否具備資訊科技相關的專業知識，都能快速理解重要術語和思維架構，同時增加許多職場上非常實用的技能，相較於缺乏資訊科技專業素養者有更多的優勢。
                            </div>
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area I</span>
                                <span className="tml">Information Systems and Data Management</span>
                                <span className="tmm">資訊系統與資料管理</span>
                                <span className="tmm">35-45%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area II</span>
                                <span className="tml">Security, Confidentiality and Privacy</span>
                                <span className="tmm">資訊安全、保密與隱私</span>
                                <span className="tmm">35-45%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area III</span>
                                <span className="tml">Considerations for System and Organization Controls (SOC) Engagements</span>
                                <span className="tmm">系統與組織控制委任案件的考量</span>
                                <span className="tmm">15-25%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="d-flex subjecttable mb100">
                    <motion.div
                                initial={{ opacity: 0, x:-100 }}
                                whileInView={{ opacity: 1, x:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="col-4">
                            <img className="subpic dis" src="./cpaImg/aud_pic.jpg" alt=""/>
                        </div>
                    </motion.div>
                    <div className="col-8">
                        <div className="fs-1 mb-3">Tax Compliance and Planning 稅務遵循與規劃 (簡稱 TCP)</div>
                        <div className="mb100">
                        <div className="tmbk">
                            在所有三選一專科 (discipline exams) 之中，TCP 這一科與 REG (稅務與法規）高度相關、可視為 REG 的進階考科，適合會計與財稅科系背景、或持相關經驗者選考。考生可在準備 REG 科目後面銜接繼續準備 TCP，將有內容連貫、提高記憶速度的效果。

                            準備 TCP 考試，將幫助您習得以下技能和專長：
                            <div className="barli">
                                <ul>
                                    <li>進階個人稅務遵循</li>
                                    <li>個人稅務 (投資、IRS、401k、退休等）規劃</li>
                                    <li>進階企業稅務遵循與規劃</li>
                                    <li>產權交易</li>
                                </ul>
                            </div>
                            準備 TCP 過程中學習到的技能，適合以下職涯發展：
                            <div className="barli">
                                <ul>
                                    <li>稅務分析師</li>
                                    <li>稅務遵循專員</li>
                                    <li>在企業、會計師事務所、政府單位、銀行、或避險基金的稅務部門工作</li>
                                    <li>經營個人稅務實業</li>
                                </ul>
                            </div>
                            Becker 的 TCP 課程由持有美國法律博士、美國律師資格、同時具備法遵實務經歷豐富的講師授課，幫助考生迅速理解法律用語和美國稅制架構，適合以美稅專長為職涯目標的考生。
                            </div>
                        </div>
                        <ul>
                            <li className="tsti">
                                <span className="tmxl">出題範圍</span>
                                <span className="tmm">題型配比</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area I</span>
                                <span className="tml">Tax Compliance and Planning for Individuals and Personal Financial Planning</span>
                                <span className="tmm">個人稅務遵循與規劃、財務規劃</span>
                                <span className="tmm">30-40%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area II</span>
                                <span className="tml">Entity Tax Compliance</span>
                                <span className="tmm">企業稅務遵循</span>
                                <span className="tmm">30-40%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area III</span>
                                <span className="tml">Entity Tax Planning</span>
                                <span className="tmm">企業稅務規劃</span>
                                <span className="tmm">10-20%</span>
                            </li>
                            <li className="gr">
                                <span className="tms">Area IV</span>
                                <span className="tml">Federal Taxation of Individuals</span>
                                <span className="tmm">聯邦稅 - 個人稅</span>
                                <span className="tmm">22–32%</span>
                            </li>
                            <li className="wt">
                                <span className="tms">Area V</span>
                                <span className="tml">Property Transactions (disposition of assets)</span>
                                <span className="tmm">產權交易 (資產處置)</span>
                                <span className="tmm">10-20%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="br mb100 mt100"></div>
            </div>
            {/* <!-- 考試時間與成績保留原則 --> */}
            <div className="container examtimeline mt100 mb100 dis">
                <div className="beckertitlename mb100" id="examtimeline">考試時間與成績保留原則</div>
                <ul className="base-timeline mb100 mt100 m-auto">
                    <li className="base-timeline__item base-timeline__item--data"data-step="STEP 1">
                        <span className="base-timeline__summary-text " 
                        >學歷認證</span>
                    </li>
                    <li className="base-timeline__item base-timeline__item base-timeline__item--data"data-step="STEP 2">
                        <span className="base-timeline__summary-text" 
                        >取得NTS</span>
                    </li>
                    <li className="base-timeline__item base-timeline__item--data"data-step="STEP 3">
                        <span className="base-timeline__summary-text " 
                        >正式考試</span>
                    </li>
                </ul>
            </div>
            <div className="container stepinfo">
                <div className="fs-3 mb-4 ">申請考試</div>
                <ul>
                    <li>Step1：完成學歷認證( 時間約需2周至2個月不等)。</li>
                    <li>Step2：報名平台的驗證，作業時間約需要6-8周不等。</li>
                    <li>Step3：接續取得NTS，以進行後續預約考場的動作。 (NTS的效期為6個月)</li>
                </ul>
                <div className="fs-3 mb-4 mt-5">預約考場</div>
                <ul>
                    <li>每週一至週五皆開放預約考試，早上、下午各一個考試時段。</li>
                    <li>考試地點不限於考生報考的身分州，例如：以關島資格報考之考生，可以選擇於 LA 的考場應考。</li>
                    <li>2020年七月起，取消每季不得重複應考之限制；考後收到成績不及格通知時，可立即再次報考該科。</li>
                    <li>所有考科不限一次考完，各次應考科數可依個人規劃申請應試。</li>
                </ul>
                <div className="fs-3 mb-4 mt-5">考試及格成績：75分，單科成績保留30個月</div>
                <ul>
                    <li>通過第一科考試後，30 個月內須通過其他3科考試，目前多州調整為30個月，即須在30個月內完成4科考試；若超過30個月完成4科考試 ，則須重新應考成績失效的科目。</li>
                </ul>
                <div className="br mb100 mt100"></div>
            </div>
            <div className="container">
                <div className="beckertitlename mb100" id="eligibility">應考步驟與報考資格</div>
                <div className="d-flex justify-content-around mb100">
                    <motion.div
                                initial={{ opacity: 0, y:-100 }}
                                whileInView={{ opacity: 1, y:0 }}
                                transition={{
                                delay: 0.3,
                                default: { ease: "linear" },
                            }}>
                        <div className="stepcircle bc dis">Step 1<br/>選州</div>
                    </motion.div>
                    <motion.div
                                initial={{ opacity: 0, y:-100 }}
                                whileInView={{ opacity: 1, y:0 }}
                                transition={{
                                delay: 0.4,
                                default: { ease: "linear" },
                            }}>
                        <div className="stepcircle fr dis">Step 2<br/>學歷認證</div>
                    </motion.div>
                    <motion.div
                                initial={{ opacity: 0, y:-100 }}
                                whileInView={{ opacity: 1, y:0 }}
                                transition={{
                                delay: 0.5,
                                default: { ease: "linear" },
                            }}>
                        <div className="stepcircle rg dis">Step 3<br/>考試申請</div>
                    </motion.div>
                    <motion.div
                                initial={{ opacity: 0, y:-100 }}
                                whileInView={{ opacity: 1, y:0 }}
                                transition={{
                                delay: 0.6,
                                default: { ease: "linear" },
                            }}>
                        <div className="stepcircle au dis">Step 4<br/>准考通知</div>
                    </motion.div>
                    <motion.div
                                initial={{ opacity: 0, y:-100 }}
                                whileInView={{ opacity: 1, y:0 }}
                                transition={{
                                delay: 0.7,
                                default: { ease: "linear" },
                            }}>
                        <div className="stepcircle mau dis">Step 5<br/>考前叮嚀</div>
                    </motion.div>
                </div>
                <div className="fs-2 mb100 text-center dis">申請門檻</div>
                <div className="text-center w-75 m-auto">美國會計師考試資格依所報考州別不同，而有不同的資格限制，其通過後申請執照要求也各不相同，報考前可依「報考目的」、「執業需求」與「現有學分數」評估州別選擇。建議如要一一研究，至NASBA 網站會是首要步驟。以下表格就華盛頓、緬因、新罕布夏州與關島地區為例，篩選出總學分數、學位資格、會計與商業學分，與取得執照等註：最新最正確的學分要求與取照規定請上NASBA</div>
                <ul className="tsbox">
                    <li className="tsti">
                        <span>　</span>
                        <span>WA</span>
                        <span>ME</span>
                        <span>NH</span>
                        <span>GU</span>
                    </li>
                    <li className="wt">
                        <span>總學分數</span>
                        <span>120</span>
                        <span>150</span>
                        <span>120</span>
                        <span>120</span>
                    </li>
                    <li className="gr">
                        <span>學士學歷</span>
                        <span>YES</span>
                        <span>YES</span>
                        <span>YES</span>
                        <span>YES</span>
                    </li>
                    <li className="wt">
                        <span>會計/商業學分</span>
                        <span>24/24</span>
                        <span>15/0</span>
                        <span>30/24<br/><p>(After 7/1/2014)</p></span>
                        <span>24/24<br/><p>可先報考，於第一次赴考後18個月內補足(註1)</p></span>
                    </li>
                    <li className="gr">
                        <span>畢業後應考</span>
                        <span>NO</span>
                        <span>NO/120 days</span>
                        <span>NO</span>
                        <span>YES/18 months</span>
                    </li>
                    <li className="wt">
                        <span>執照總學分需求</span>
                        <span>150</span>
                        <span>150</span>
                        {/* style="font-size: 0.5em" */}
                        <span>120<br/><p>(Before 7/1/2014)</p></span>
                        <span>150<br/></span>
                    </li>
                    <li className="gr">
                        <span>執照工作經驗需求</span>
                        <span>1 year</span>
                        <span>2 years</span>
                        <span>1 year</span>
                        <span>1 year</span>
                    </li>
                </ul>
                註：各州相關規定可能隨時異動，請依 NASBA 官方公告為準。
                <div className="br mb100"></div>
            </div>
            <div className="container-fluid">
                <div className="beckertitlename mb100" id="eligibility">考試花費成本</div>
                
            </div>
            <div className="container">
                <div className="ue_bk">
                    美國會計師考試規費依所報考州別有所不同，實際應考地點也依各區域酌收不同的考場費，<br/>

                    以下表格就華人最常選擇之關島考生身分、加上赴美國本土應考為例，列舉考取美國註冊會計師考試必需花費項目：<br/><br/>

                    <div className="text-muted">註：金額數字請依官方考試單位 NASBA 網站更新顯示為準。</div>
                </div>
                <table className="table table-bordered mt-2">
                    <thead className="table-dark">
                        <tr>
                        <th scope="col">流程階段</th>
                        <th scope="col">費用項目</th>
                        <th scope="col">費用金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>學歷認證</th>
                            <td>FACS</td>
                            <td>$175.00</td>
                        </tr>
                        <tr>
                            <th rowspan="2">報名考試</th>
                            <td>關島 (NASBA) 首次報考審核費 Education Evaluation Application</td>
                            <td>$133.00</td>
                        </tr>
                        <tr>
                            <td>關島 (NASBA) 考科單科*4 Exam Section Application Fee</td>
                            <td>$1,490.56</td>
                        </tr>
                        <tr>
                            <th>考場費</th>
                            <td>美國本土應考，無需支付考場費</td>
                            <td>$0.00</td>
                        </tr>
                        <tr>
                            <td className="" colspan="2"><small>小計 (美金)</small></td>
                            <td>$1,798.56</td>
                        </tr>
                        <tr>
                            <td colspan="2"><small>小計 (換算台幣)</small></td>
                            <td>NT$57,830</td>
                        </tr>
                        <tr>
                            <td colspan="3" className=""></td>
                        </tr>
                        <tr>
                            <th>出國考試</th>
                            <td>美國LA地區，8天7夜來回機票+飯店住宿</td>
                            <td>NT$52,000</td>
                        </tr>
                        <tr>
                            <th>教材</th>
                            <td>Becker 全修方案</td>
                            <td>NT$113,000</td>
                        </tr>
                        <tr>
                            <th colspan="2">花費總額 (台幣)</th>
                            <td>NT$220,546</td>
                        </tr>
                    </tbody>
                </table>
                <div className="text-right costt mb100">製表：2023年8月</div>
            </div>
            
            <div className="container">
                <div className="br mb100"></div>
                <div className="fs-2 mb-3 text-center fw-bold">雙照計劃</div>
                <div className="text-center mb100">USCPA VS. ROCCPA<br/>領有外國會計師證書，經考選部認可者，得申請部分科目免試</div>
                <div className="d-flex w-75 douicon">
                    <div className="col-6 text-center">
                        <img className="m-auto" src="./cpaImg/dou_icon2.svg"alt=""/>
                        <div className="fw-bold mt-3">抵免科目<br/>中會、高會、成會、國文</div>
                    </div>
                    <div className="col-6 text-center">
                        
                        <img className="m-auto" src="./cpaImg/dou_icon.svg"alt=""/>
                    <div className="fw-bold mt-3">必考科目<br/>審計、稅法、公司法<br/>&<br/>證券交易法&商業會計法</div>
                    </div>
                </div>
                <div className="fs-2 mb-3 text-center fw-bold">通過USCPA考試後</div>
                <div className="text-center w-75 m-auto mt-5 mb-5">
                    需向所屬州別申請 USCPA 執照於隔年3月向考選部提出台灣會計師考試抵免申請，5月報考8月份台灣會計師專技考試若「台灣會計師3科考試」與「抵免申請」兩件事相繼於三年內完成（無先後順序），即可取得台灣會計師執照，拿取台美雙照頭銜。
                </div>
                <div className="br mt100 mb100"></div>
                
                <div className="m-auto w-100">
                    {/* <!-- 證照互認協議 --> */}
                    <div className="fs-2 mb-3 text-center fw-bold" id="protocol">證照互認協議</div>
                    <div className="protocol mt100 mb100">
                        <img className="m-auto" src="./cpaImg/protocol.jpg"alt=""/>
                        <div className="fs-2 mt-3 mb-3 text-center fw-bold" id="protocol2">相互承認協議</div>
                        <div className="w-50 text-center m-auto">NASBA / AICPA國際資格鑑定委員會（IQAB）是美國會計專業與其他“服務貿易總協定”（GATS）簽署國之間的聯繫。通過相互承認協議（MRA），來自另一個國家的合格專業會計師可以在美國執業，而無需完全重新認證，同樣承認希望在同一個國家執業的美國註冊會計師。</div>
                        <img className="mt100 m-auto" src="./cpaImg/teacher_banner.jpg"alt=""/>
                        <div className="fs-2 mt-3 mb-3 text-center fw-bold">當前協議</div>
                        <div className="w-50 text-center m-auto">IQAB目前已經與以下專業機構建立了MRA</div>
                    </div>
                </div>
                <div className="container-fluid mb100">
                    <div className="row">
                        <div className="col-sm-3 ctbox ctl">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct01.png" alt="澳洲特許會計師協會(ICAA)" />
                            <p>澳洲特許會計師協會(ICAA)</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct02.png" alt="CPA Canada (CPAC)" />
                            <p>CPA Canada (CPAC)</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct03.png" alt="蘇格蘭特許會計師協會(ICAS)" />
                            <p>蘇格蘭特許會計師協會(ICAS)</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct04.png" alt="愛爾蘭特許會計師公會(CAI)" />
                            <p>愛爾蘭特許會計師公會(CAI)</p>
                        </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-4 ctbox ctl">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct05.png" alt="墨西哥公共會計師公會(IMCP)" />
                            <p>墨西哥公共會計師公會(IMCP)</p>
                        </div>
                        </div>
                        <div className="col-sm-4 ctbox">
                        <div className="ct-content">
                            <img src="./cpaImg/ic_ct06.png" alt="紐西蘭特許會計師協會(NZICA)" />
                            <p>紐西蘭特許會計師協會(NZICA)</p>
                        </div>
                        </div>
                        
                    </div>
                    </div>

            </div>
        </>
    );
}
export default Cpa;